import {HttpClientModule} from '@angular/common/http';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {QuillModule} from 'ngx-quill';

import {SharedModule} from '../../shared/shared.module';
import {CasePersonService} from '../people/case-person.service';
import {CaseAssetService} from './case-asset.service';
import {CaseAssetCreateComponent} from './create/create.component';
import {CaseAssetEditComponent} from './edit/edit.component';
import {CaseAssetFormComponent} from './form/form.component';
import {CaseAssetListComponent} from './list/list.component';

@NgModule({
  declarations: [
    CaseAssetFormComponent,
    CaseAssetCreateComponent,
    CaseAssetEditComponent,
    CaseAssetListComponent,
  ],
  imports: [
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    QuillModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
  ],
  exports: [CaseAssetListComponent],
  providers: [CaseAssetService, CasePersonService],
})
export class CaseAssetRoutingModule {}
